

export const isUUID = (uuid: string) => {
    let s = "" + uuid;
    const isMatch = s.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
    return isMatch !== null;
}